import {lazyLoad} from 'utils/loadable';

export const TreePage = lazyLoad(
  () => import(/* webpackChunkName:'tree-page' */ './index'),
  module => module.TreePage
);
